import {
  AssistantFeedbackRatingEnum,
  AssistantFeedbackReasonEnum,
} from 'src/api/ProactApiClient';

export const FEEDBACK_COMMENT_MAX_LENGTH = 1000;

export interface FeedbackReasonOption {
  value: AssistantFeedbackReasonEnum;
  label: string;
  /** Stable URL token for deep links (`?reasons=wrong-data`). */
  slug: string;
}

/** Mirrors the server enum order; the API rejects any other value. */
export const FEEDBACK_REASONS: readonly FeedbackReasonOption[] = [
  {value: AssistantFeedbackReasonEnum.WrongData, label: 'Wrong data', slug: 'wrong-data'},
  {value: AssistantFeedbackReasonEnum.MissingData, label: 'Missing data', slug: 'missing-data'},
  {
    value: AssistantFeedbackReasonEnum.Misunderstood,
    label: 'Misunderstood the question',
    slug: 'misunderstood',
  },
  {value: AssistantFeedbackReasonEnum.TooSlow, label: 'Too slow', slug: 'too-slow'},
  {value: AssistantFeedbackReasonEnum.Other, label: 'Other', slug: 'other'},
];

export const feedbackReasonLabel = (
  reason: AssistantFeedbackReasonEnum | null | undefined
): string =>
  reason === null || reason === undefined
    ? ''
    : (FEEDBACK_REASONS.find(option => option.value === reason)?.label ??
      `Reason ${reason}`);

export const feedbackRatingLabel = (rating: AssistantFeedbackRatingEnum): string =>
  rating === AssistantFeedbackRatingEnum.Up ? 'Good response' : 'Bad response';

/**
 * A reply is rateable when it is a persisted assistant row with no tool calls (the final row
 * of a turn); tool-loop iteration rows are not.
 * @registry Whether a Scout message row can take a thumbs vote.
 */
export const isRateableMessage = (message: {
  role: string;
  toolCalls?: readonly unknown[] | null;
}): boolean =>
  message.role.toLowerCase() === 'assistant' &&
  (message.toolCalls?.length ?? 0) === 0;
